import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { CompanyVerificationHttpClient } from './company-verification.http-client';
import { CompanyVerificationActions } from './company-verification.store';

@Injectable({
  providedIn: 'root',
})
export class CompanyVerificationEffects {
  private readonly actions$ = inject(Actions);
  private readonly httpApi = inject(CompanyVerificationHttpClient);

  public effects = createEffectFactory(CompanyVerificationActions, this.actions$);

  public fetch$ = this.effects(CompanyVerificationActions.fetch, () => this.httpApi.fetch());

  public verify$ = this.effects(CompanyVerificationActions.update, ({ payload }) =>
    this.httpApi.verify(payload).pipe(map(response => response)),
  );
}
